import { type FC, type ReactNode } from "react";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import * as Styled from "./ProfileMenuV2.styled";

export type ProfileMenuV2Props = {
    fullName: string;
    isLoading?: boolean;
    profileLinks: ReactNode;
    otherLinks: ReactNode;
    logoutAction?: ReactNode;
};

export const ProfileMenuV2: FC<ProfileMenuV2Props> = ({
    fullName,
    isLoading = false,
    profileLinks,
    otherLinks,
    logoutAction,
}) => {
    const isDesktop = useIsDesktop();
    const { t } = useTypedTranslation();

    return (
        <Styled.Root sx={{ px: isDesktop ? undefined : 4 }}>
            <Styled.Section>
                <Styled.PortalTitle>{t("profile.personalInfo.portalTitle")}</Styled.PortalTitle>
                <Styled.ClientName withoutScale>
                    {isLoading ? <Styled.LoadingName /> : fullName}
                </Styled.ClientName>
                {profileLinks}
            </Styled.Section>
            <Styled.Section>
                <Styled.ClientName withoutScale>{t("profile.menu.other")}</Styled.ClientName>
                {otherLinks}
            </Styled.Section>
            {!isDesktop && logoutAction}
        </Styled.Root>
    );
};